import { PDFViewer } from "@react-pdf/renderer";
import DocumentoCracha from "./DocumentoCracha";
import { useEffect, useState } from "react";
import axios from "axios";

const Preview = () => {

    const [loading, setLoading] = useState(true)
    const [dadosMock, setDadosMock] = useState([])

    useEffect(() => {

        fetchData();

    }, [])

    const fetchData = async () => {

        const formData = new FormData();
        formData.append('cpf', '39621851866')

        const { data } = await axios.post('http://localhost/Painel/API/Treinamentos/GenerateCracha/', formData);
        setDadosMock(data);

        setLoading(false)

    }

    if (loading) {

        return (

            <p>CARREGANDO...</p>

        )

    }

    return (
        <>
            <PDFViewer width="100%" height="900" >
                <DocumentoCracha dados={dadosMock} />
            </PDFViewer>
            <img src={ dadosMock.IMAGEM } />
        </>

    )

}

export default Preview;